import React, { useEffect } from 'react'
import {
    IconButton,
    Menu,
    MenuHandler,
    MenuList,
    MenuItem,
    Spinner
} from "@material-tailwind/react";

import TariffPdf from './TariffPdf'

import { BlobProvider, } from '@react-pdf/renderer';


import { useShared } from '../../hooks/useShared';
import AIcon from '../../components/partials/AIcon';




export default function AMenu({ v }) {
    const { auth } = useShared();

    const setOpenData = (flag) => {
        console.log("object");
        v?.handleMenu(v?.model, flag)
    }


    return (
        <Menu
            animate={{
                mount: { y: 0 },
                unmount: { y: 25 },
            }}
        >
            <MenuHandler>
                <IconButton disabled={auth.hasRole([3])} variant="text" className={`h-5 $`}>
                    <AIcon name="ellipsis-horizontal-outline" className="text-main-color text-lg" />
                </IconButton>
            </MenuHandler>

            <MenuList className="min-w-[100px] bg-main-color p-1">

                <MenuItem className={`flex  items-center p-1 text-white `} onClick={() => setOpenData('pdf')}>
                    <AIcon name={`logo-foursquare`} className="mr-2" />  PDF ايجاد
                    {/* <BlobProvider document={<TariffPdf v={{ model: v.model, com, consts, http, Num2persian }} />}
                        fileName={'Tariff.pdf'}>
                        {({ blob, url, loading, error }) => {
                            return (<> {loading ? <div className='flex '> <Spinner className="h-4 w-4 mr-1" /> PDF ...</div> : !loading && url ? <a href={url} target="_blank" rel="noreferrer"> PDF ايجاد   </a> : null} </>)
                        }}
                    </BlobProvider> */}

                </MenuItem>
                <hr className="my-1 text-cyan-900" />
                <MenuItem className={`flex  items-center p-1 text-white `} onClick={() => setOpenData('upload file')}>
                    <AIcon name={`cloud-upload-outline`} className="mr-2" /> آپلود فایل
                </MenuItem>

                <hr className="my-1 text-cyan-900" />
                {(auth.hasRole([1, 2]) || (v?.model?.status === 0 && auth.isCreator(v?.model?.creator_id))) && <><MenuItem className={`flex  items-center p-1 text-white `} onClick={() => setOpenData('edit')}>
                    <AIcon name={`create-outline`} className="mr-2" /> ویرایش
                </MenuItem>
                    <hr className="my-1 text-cyan-900" /></>}

                {(v?.model?.status === 1 && auth.hasRole([1, 2])) && <>
                    <MenuItem className={`flex  items-center p-1 text-white `} onClick={() => setOpenData('approve')}>
                        <AIcon name={`checkmark-circle-outline`} className="mr-2" /> تایید
                    </MenuItem>
                    <hr className="my-1 text-cyan-900" /></>}
                {(auth.hasRole([1, 2])) && <> <MenuItem className={`flex  items-center p-1 text-white `} onClick={() => setOpenData('delete')}>
                    <AIcon name={`trash-outline`} className="mr-2" /> حذف
                </MenuItem></>}


            </MenuList>
        </Menu>
    )
}
